import React from 'react';
import {FormattedMessage} from 'react-intl';

export default {
  fields: [
    {
      type: 'text',
      name: 'email',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='userProfile.email'/>
          </div>
        ),
        required: true
      }
    },
    {
      type: 'text',
      name: 'firstName',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='userProfile.firstName' />
          </div>
        ),
        required: true
      }
    },
    {
      type: 'text',
      name: 'lastName',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='userProfile.lastName' />
          </div>
        ),
        required: true
      }
    },
    {
      type: 'text',
      name: 'username',
      props: {
        label: (
          <div>
            <i className='asterisk icon inline' />
            <FormattedMessage id='userProfile.username' />
          </div>
        ),
        required: true
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/Profile/profileFormConfig.js